// Auto-generated from _colors.scss
// Source: packages/shared/css/utils/variables/_colors.scss
//
// 🚨 DO NOT EDIT THIS FILE MANUALLY
// To update: npm run types:sync

export const Colors = {
  accent: "#555",
  "account-management-team-customer_success": "#f4b177",
  "account-management-team-foundation_corporate": "#ab84e5",
  "account-management-team-foundation_dedicated_support": "#bae7ff",
  "account-management-team-foundation_government": "#3359e3",
  "account-management-team-media_analysis_and_insights": "#fff1b8",
  "account-management-team-new_business": "#ef7f79",
  "account-management-team-onboarding": "#7ed8d2",
  "account-management-team-streem_social": "#efdbff",
  active: "#ff7875",
  black: "#000",
  blog: "#f06a35",
  "blue-grey": "#9299a7",
  "blue-link": "#3d70b2",
  "blue-link-darker": "#30588c",
  body: "#f5f7f9",
  "body-background": "#f5f7f9",
  "body-color": "#444",
  brown: "#b17483",
  cancel: "#e65b50",
  Channel: "#ff4d4f",
  "clip-blue": "#484d81",
  "clip-seeker-blue": "#1a2162",
  "clip-tile": "#a2a9b5",
  "control-border": "#b9bdcd",
  danger: "#e10001",
  dark: "#222",
  "dark-purple": "#352d67",
  "darkdenim-8": "#303540",
  "darkdenim-9": "#282c39",
  "darkdenim-10": "#191e2b",
  "daybreak-blue": "#1890ff",
  "deeppurple-9": "#4a4277",
  "deeppurple-9-5": "#413970",
  "deeppurple-10": "#352d67",
  "default-tag-color": "#757575",
  "ds-blue-1": "#e6f7ff",
  "ds-blue-2": "#bae7ff",
  "ds-blue-3": "#91d5ff",
  "ds-blue-4": "#69c0ff",
  "ds-blue-5": "#40a9ff",
  "ds-blue-6": "#1890ff",
  "ds-blue-7": "#096dd9",
  "ds-blue-8": "#0050b3",
  "ds-blue-9": "#003a8c",
  "ds-blue-10": "#002766",
  "ds-cision-menu": "#007fa8",
  "ds-cision-social-menu": "#9664d8",
  "ds-cyan-1": "#e6fffb",
  "ds-cyan-2": "#b5f5ec",
  "ds-cyan-3": "#87e8de",
  "ds-cyan-4": "#5cdbd3",
  "ds-cyan-5": "#36cfc9",
  "ds-cyan-6": "#13c2c2",
  "ds-cyan-7": "#08979c",
  "ds-cyan-8": "#006d75",
  "ds-cyan-9": "#00474f",
  "ds-cyan-10": "#002329",
  "ds-darkblue-1": "#f0f5ff",
  "ds-darkblue-2": "#d6e4ff",
  "ds-darkblue-3": "#adc6ff",
  "ds-darkblue-4": "#85a5ff",
  "ds-darkblue-5": "#597ef7",
  "ds-darkblue-6": "#2f54eb",
  "ds-darkblue-7": "#1d39c4",
  "ds-darkblue-8": "#10239e",
  "ds-darkblue-9": "#061178",
  "ds-darkblue-10": "#030852",
  "ds-denim-1": "#f5f7f9",
  "ds-denim-2": "#e5eaef",
  "ds-denim-3": "#d4dae0",
  "ds-denim-4": "#bbc1cb",
  "ds-denim-5": "#a2a9b5",
  "ds-denim-6": "#89909f",
  "ds-denim-7": "#70788a",
  "ds-denim-8": "#575f74",
  "ds-denim-9": "#3e475e",
  "ds-denim-9-5": "#363c52",
  "ds-denim-10": "#2a3247",
  "ds-election-blue": "#529fe6",
  "ds-gray-1": "#444",
  "ds-green-1": "#e1fde7",
  "ds-green-2": "#c3f7cf",
  "ds-green-3": "#9df3b0",
  "ds-green-4": "#7ced95",
  "ds-green-5": "#70d687",
  "ds-green-6": "#55bd6c",
  "ds-green-7": "#4b9f5d",
  "ds-green-8": "#318042",
  "ds-green-9": "#216630",
  "ds-green-10": "#12471e",
  "ds-navy-1": "#e7e8ee",
  "ds-navy-2": "#d1d3e0",
  "ds-navy-3": "#b9bbcf",
  "ds-navy-4": "#a4a7c1",
  "ds-navy-5": "#8c90b1",
  "ds-navy-6": "#767ba2",
  "ds-navy-7": "#5f6491",
  "ds-navy-8": "#484c7f",
  "ds-navy-9": "#313772",
  "ds-navy-10": "#1a2161",
  "ds-navy-11": "#030b4e",
  "ds-orange-1": "#fff5e7",
  "ds-orange-2": "#ffe0bd",
  "ds-orange-3": "#ffc894",
  "ds-orange-4": "#ffae6c",
  "ds-orange-5": "#ff9143",
  "ds-orange-6": "#fa6f19",
  "ds-orange-7": "#de4f03",
  "ds-orange-8": "#ad3701",
  "ds-orange-9": "#872601",
  "ds-orange-10": "#611801",
  "ds-pink-1": "#fff0f6",
  "ds-pink-2": "#ffd6e7",
  "ds-pink-3": "#ffadd2",
  "ds-pink-4": "#ff85c0",
  "ds-pink-5": "#f759ab",
  "ds-pink-6": "#eb2f96",
  "ds-pink-7": "#c41d7f",
  "ds-pink-8": "#9e1068",
  "ds-pink-9": "#780650",
  "ds-pink-10": "#520339",
  "ds-purple-1": "#f9f0ff",
  "ds-purple-2": "#efdbff",
  "ds-purple-3": "#d3adf7",
  "ds-purple-4": "#b37feb",
  "ds-purple-5": "#9254de",
  "ds-purple-6": "#722ed1",
  "ds-purple-7": "#531dab",
  "ds-purple-8": "#391085",
  "ds-purple-9": "#22075e",
  "ds-purple-10": "#18024e",
  "ds-red-1": "#fff1f0",
  "ds-red-2": "#ffccc7",
  "ds-red-3": "#ffa39e",
  "ds-red-4": "#ff7875",
  "ds-red-5": "#ff4d4f",
  "ds-red-6": "#f5222d",
  "ds-red-7": "#cf1322",
  "ds-red-8": "#a8071a",
  "ds-red-9": "#820014",
  "ds-red-10": "#5c0011",
  "ds-yellow-1": "#fffbe6",
  "ds-yellow-2": "#fff1b8",
  "ds-yellow-3": "#ffe58f",
  "ds-yellow-4": "#ffd666",
  "ds-yellow-5": "#ffc53d",
  "ds-yellow-6": "#faad14",
  "ds-yellow-7": "#d48806",
  "ds-yellow-8": "#ad6800",
  "ds-yellow-9": "#874d00",
  "ds-yellow-10": "#613400",
  "election-blue": "#529fe6",
  "election-deep-red": "#e66c69",
  "election-link-box": "#f6f9ff",
  "election-navy": "#767ba2",
  "election-polls": "#e7e8ee",
  "engage-bg-draft": "#ffe0bd",
  "engage-bg-draft-hover": "#ffc894",
  "engage-bg-facebook": "#395185",
  "engage-bg-instagram": "#f759ab",
  "engage-bg-linkedin": "#0077b5",
  "engage-bg-not-approved": "#f5f7f9",
  "engage-bg-not-approved-hover": "#e5eaef",
  "engage-bg-not-sent": "#ffccc7",
  "engage-bg-not-sent-hover": "#ffa39e",
  "engage-bg-scheduled": "#f5f7f9",
  "engage-bg-sent": "#c3f7cf",
  "engage-bg-sent-hover": "#9df3b0",
  "engage-bg-twitter": "#14171a",
  "engage-border-draft": "#ffc894",
  "engage-border-not-approved": "#e5eaef",
  "engage-border-not-sent": "#ffccc7",
  "engage-border-scheduled": "#e5eaef",
  "engage-border-sent": "#9df3b0",
  error: "#ff7875",
  facebook: "#61749d",
  "faded-grey": "#666",
  forum: "#ffb649",
  green: "#49d067",
  "green-dark": "green",
  grey: "#9b9b9b",
  "grey-separator": "#e2e2e2",
  "high-value": "#b5aa48",
  "high-value-soft": "#e3dfbb",
  "hover-background": "#e6ebf0",
  info: "#31ccec",
  "input-grey": "#f2f2f2",
  instagram: "#e3787c",
  lavender: "#b05293",
  light: "#bdbdbd",
  lightbox: "#33353b",
  "lighter-grey": "#f3f3f3",
  magazine: "#f759ab",
  "menu-background": "#202020",
  "menu-competitor-panel": "#2b2e48",
  "menu-hover-background": "rgb(68 68 68 / 50%)",
  "menu-media-panel": "#131b62",
  "menu-social-bar": "#422287",
  "mid-grey": "#5e616a",
  negative: "#f29c9c",
  neutral: "#e0e1e2",
  "notifications-red": "#cd4b4b",
  online: "#1890ff",
  "organisation-report-spec-product_afr_pdf": "#87e8de",
  "organisation-report-spec-product_australia_back_page_summaries": "#597ef7",
  "organisation-report-spec-product_australia_front_page_summaries": "#597ef7",
  "organisation-report-spec-product_automatic_summary": "#a2a9b5",
  "organisation-report-spec-product_coverage_summaries": "#ffa39e",
  "organisation-report-spec-product_front_and_back_page_summaries": "#ffae6b",
  "organisation-report-spec-product_front_pages_pdf": "#ffe58f",
  "organisation-report-spec-product_in_focus": "#ff4d4f",
  "organisation-report-spec-product_leading_news_table": "#d3d9df",
  "organisation-report-spec-product_new_zealand_back_page_summaries": "#597ef7",
  "organisation-report-spec-product_new_zealand_front_page_summaries":
    "#597ef7",
  "organisation-report-spec-product_print_pdf": "#b37feb",
  "organisation-report-spec-product_public_holiday_delivery": "#36cec9",
  "organisation-report-spec-product_renewal": "#76d0dd",
  "organisation-report-spec-product_report_pdf": "#85a5ff",
  "organisation-report-spec-product_stock_prices": "#ffc53d",
  "organisation-report-spec-product_twitter_table": "#8fd4ff",
  "organisation-report-status_approved": "#fa6f19",
  "organisation-report-status_building": "#6bc1ff",
  "organisation-report-status_delivered": "#4ba05d",
  "organisation-report-status_draft": "#096dd7",
  "organisation-report-status_error": "#a6071a",
  "organisation-report-status_not_started": "#586074",
  "organisation-report-status_past_due": "#f5242e",
  "organisation-report-status_proofed": "#fa6f19",
  "organisation-report-status_scheduled": "#6bc1ff",
  "organisation-report-status_sending": "#71d688",
  "pale-blue": "#d1d3e0",
  "pale-grey": "#d9d9d9",
  "pale-sky": "#67757e",
  "pale-white": "#f0f0f0",
  pink: "#d94d80",
  podcast: "#0ba4af",
  positive: "#21ba45",
  primary: "#444",
  "primary-streem": "#131b62",
  print: "#2f54eb",
  "priority-high": "#ffa39e",
  "priority-high-dark": "#ff7875",
  "priority-low": "#9df3b0",
  "priority-low-dark": "#70d687",
  "priority-medium": "#ffd666",
  "priority-medium-dark": "#ffad14",
  purple: "#7d6091",
  radio: "#ed7100",
  radio_media_request: "#ed7100",
  radio_segment: "#ed7100",
  RadioStation: "#ed7100",
  "react-score-warning": "#cd1323",
  reddit: "#fb7a4a",
  reddit_post: "#9254de",
  reddit_post_comment: "#9254de",
  secondary: "#ddd",
  "sentiment-balanced": "#444",
  "sentiment-negative": "#ff7875",
  "sentiment-positive": "#49d067",
  "sentiment-trending-negative": "#ffae6c",
  "sentiment-trending-positive": "#69c0ff",
  "service-level-customer_success_tier_five": "#767ba2",
  "service-level-customer_success_tier_four": "#5f6491",
  "service-level-customer_success_tier_three": "#484c7f",
  "service-level-standard_account_management_tier_one": "#030b4e",
  "service-level-standard_account_management_tier_three": "#313772",
  "service-level-standard_account_management_tier_two": "#1a2161",
  "service-level-tier_one": "#030b4e",
  "service-level-tier_one_plus": "#000",
  "service-level-tier_two": "#5f6491",
  "services-additional_clients_keywords": "#faad14",
  "services-additional_users": "#faad14",
  "services-ave": "#4f5483",
  "services-cald": "#4f5483",
  "services-ccp": "#2b2e46",
  "services-cla": "#4f5483",
  "services-crm": "#56bd6c",
  "services-der": "#20642f",
  "services-financial_times": "#4f5483",
  "services-influencer_social": "#ab84e5",
  "services-insights": "#4b9f5d",
  "services-insights_plus": "#4b9f5d",
  "services-instant_edit_downloads": "#ca587f",
  "services-instant_edit_transcripts": "#ca587f",
  "services-international_lite": "#4f5483",
  "services-international_max": "#4f5483",
  "services-international_plus": "#4f5483",
  "services-lexisnexis": "#4f5483",
  "services-magazines": "#f08dbe",
  "services-media_item_downloads": "#ca587f",
  "services-new_zealand_content": "#4f5483",
  "services-new_zealand_online_content": "#4f5483",
  "services-new_zealand_print_content": "#4f5483",
  "services-nla": "#4f5483",
  "services-outreach": "#56bd6c",
  "services-podcasts": "#7ed8d2",
  "services-print": "#3359e3",
  "services-radio_tv_broadcasts": "#f4b177",
  "services-risk_score": "#4f5483",
  "services-search_available_content": "#131e5e",
  "services-sky_news": "#ef7f79",
  "services-social_engage": "#714da8",
  "services-social_listen": "#714da8",
  "services-streaming_links": "#f4b177",
  "services-traditional": "#131e5e",
  "services-transcripts": "#ca587f",
  "services-tveyes": "#4f5483",
  "sidebar-darkgrey": "#e6e6e6",
  "sidebar-grey": "#d5d5d5",
  silver: "silver",
  "silver-white": "#eee",
  "silver-whiter": "#fafafa",
  social: "#9254de",
  "social-gradient": "linear-gradient(90deg, #9254de 0.5%, #f759ab 100%)",
  "social-verified": "#329fec",
  soft: "#767676",
  "soft-grey": "rgb(118 118 188 / 45%)",
  softer: "#a5a5a5",
  teal: "#006378",
  "text-dark": "#3e475e",
  tv: "#f5242e",
  tv_media_request: "#f5242e",
  tv_segment: "#f5242e",
  TvChannel: "#f5242e",
  twitter: "#77bdf1",
  warning: "#fcdc59",
  white: "#fff",
  yellow: "#f9f871",
  youtube: "#d54b3f",
} as const;

export type Color = keyof typeof Colors;
export type ColorValue = (typeof Colors)[Color];

// Generated 330 color definitions
